

//get api gateway url everytime there is a deployment change this value
const apiurl = process.env.REACT_APP_API_URL || '';


//API to post customer info to dynamo db and get skill id
export function postDynamo(fullname, email, phone, category, question, product, catLang){

    const getSkillIdUrl = apiurl + '/userinfo';
    return fetch(getSkillIdUrl,
        { method: 'POST', mode: 'cors',
            body: JSON.stringify
            ({
                phonenumber: phone,
                question: question,
                fullname: fullname,
                email: email,
                category: category,
                productValue: product, //product information for the dynamo db lookup
                catLang: catLang  //categoryLanguage for the dynamo db value lookup
            })
        }).then(response => response.json())
        .catch(error => {
            return Promise.resolve(null) // return null if there are any errors
        });
};

//API to get estimated wait time
export function getWaitTime(skillId){

    const getWaitTimeUrl = apiurl + '/queuecounter';
    return fetch(getWaitTimeUrl,
        {method: "POST", mode: "cors",
            body: JSON.stringify
            ({
                skillid: skillId  //get skill id from mapping table
            })

        }).then(response => response.json())
        .catch(error => {
            return Promise.resolve(null) // return null if there are any errors
        });



};

// API for "callnow"
// Send details to the script id for agent messaging and place a call
export function getContactIdInfo(email, phone, question, skillId, fullName){

    const postCallNowApi = apiurl + '/queuecallback';
    return fetch(postCallNowApi,
        { method: 'POST', mode: 'cors',
            body: JSON.stringify
            ({
                question: question,
                email: email,
                phonenumber: phone,
                skillid: skillId, //get skill id from mapping table
                fullname: fullName //send full name to queue counter lambda function
            })
        }).then(response => response.json())
        .catch(error => {
            return Promise.resolve(null) // return null if there are any errors
        });
};

